import React from 'react'
import moment from 'moment'
import { component_tool } from '@/tool'
const { WizRow, WizCol, WizTypography, WizComponent } = component_tool;
const { Title } = WizTypography

export default class QsHeader extends WizComponent {
    render() {
        const { preview, title, intro, submissionDate, userName, fullName } = this.props
        return (
            <div className="question-header">
                <WizRow className='question-header-title' type='flex' justify='center' align='middle'>
                    <WizCol span={20}>
                        <Title className='header-title' level={4}>{title}</Title>
                    </WizCol>
                </WizRow>
                <WizRow type='flex' justify={!preview ? 'end' : 'center'} align='middle'>
                    <WizCol>
                        {
                            !preview ?
                                (
                                    <div><span style={{ margin: '0 20px 0 45px' }}>提交时间：{submissionDate?moment(submissionDate).format('YYYY-MM-DD HH:mm'):'--'}</span></div>
                                )
                                :
                                (
                                    <div className='header-intro' dangerouslySetInnerHTML={{ __html: intro }}/>
                                )
                        }
                    </WizCol>
                </WizRow>
            </div>
        )
    }
}